// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("@ey-xd/motif-core/src/assets/fonts/EYInterstate-Regular.woff2", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_1___ = new URL("@ey-xd/motif-core/src/assets/fonts/EYInterstate-Italic.woff2", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_2___ = new URL("@ey-xd/motif-core/src/assets/fonts/EYInterstate-Bold.woff2", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_3___ = new URL("@ey-xd/motif-core/src/assets/fonts/EYInterstate-BoldItalic.woff2", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_4___ = new URL("@ey-xd/motif-core/src/assets/fonts/EYInterstate-Light.woff2", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_5___ = new URL("@ey-xd/motif-core/src/assets/fonts/EYInterstate-LightItalic.woff2", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_6___ = new URL("../images/error-icon.svg", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_7___ = new URL("../images/success-icon.svg", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_8___ = new URL("../images/warning-icon.png", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_9___ = new URL("../images/info-icon.png", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
var ___CSS_LOADER_URL_REPLACEMENT_1___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_1___);
var ___CSS_LOADER_URL_REPLACEMENT_2___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_2___);
var ___CSS_LOADER_URL_REPLACEMENT_3___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_3___);
var ___CSS_LOADER_URL_REPLACEMENT_4___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_4___);
var ___CSS_LOADER_URL_REPLACEMENT_5___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_5___);
var ___CSS_LOADER_URL_REPLACEMENT_6___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_6___);
var ___CSS_LOADER_URL_REPLACEMENT_7___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_7___);
var ___CSS_LOADER_URL_REPLACEMENT_8___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_8___);
var ___CSS_LOADER_URL_REPLACEMENT_9___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_9___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* rastwe: 10/17/17 - I'm adding an @import here to point at the
 *  EY Online Style Guide. This is required because of some issues with
 *  The "extract-text-webpack-plugin", or webpack itself. In either case,
 *  relying on the @import order instead of webpack fixes the issue.
 *  TODO: undo this later, and just refer to the OSG in the top-level
 *  component. */
/**
 * Global LESS variables
 */
/* Colors */
/* Layout */
.global-lh-pd-fs {
  padding: 0 10px;
}
:export {
  ey-buttercup: #ffee99;
  ey-green: #2c973e;
  ey-green-50: #95cb89;
  ey-lilac: #ac98db;
  ey-lilac-50: #d8d2e0;
  ey-link-blue: #336699;
  ey-link-blue-50: #7fd1d6;
  ey-purple: #91278f;
  ey-purple-50: #c893c7;
  ey-red: #f04c3e;
  ey-white: #fff;
  ey-yellow: #ffd200;
  ey-orange: #f7941d;
  gray-light: #f0f0f0;
  gray: #c0c0c0;
  gray-half: #81858b;
  gray-34th: #44494f;
  gray-dark: #24282d;
  gray-charcoal: #333;
  grey-50: #3b3838;
  grey-70: #7f7f7f;
  ey-sky-blue: #35b7c0;
  ey-teal: #00a3ae;
  gray-100: #44494f;
  grey-light-bg: #f4f4f4;
  gray-14th: #bec1c7;
  ey-ready-green: #00a4ae;
  ey-inqueuebadge: #fcd5b5;
  ey-inprogressbadge: #d7e4bd /* Layout */;
  footer-height: 30px;
  footer-padding: 5px;
  nav-height: 80px;
  screen-xs: 480px;
  screen-sm: 768px;
  screen-md: 992px;
  screen-lg: 1200px;
  cursor-disabled: default;
  labelWeightNormal: normal;
  z-index-select-dropdown: 1060;
  input-color-placeholder: #999;
  channelToolsWidth: 100%;
  baseFontSize: 12px;
  toggleButtonBorder: #d9dadb;
  toggleActiveButton: #ffe600;
  buttonBorderRadius: 4px;
  inputBorderRadius: 4px;
  textColorWhite: #fff;
  inputActiveBorder: #f7941d;
  label-font-weight: bold;
  baseVMFontSize: 0.77vw;
  label-placeholder-color: #81858b;
  formComponentHeight: 30px;
  typeaheadTokenColor: #e7f4ff;
  typeheadLabelColor: #1f8dd6;
  typeheadDisabledColor: #ddd;
  typeheadSelectedColor: #1f8dd6;
  buttonDisabled: #ddd;
  buttonActiveBorder: #bde7ea;
  opacity-transparent: 1;
  opacity-blur: 0.8;
  ey-border-radius: 4px;
  cursor-default: default;
  cursor-pointer: pointer;
  boxshadow-none: none;
  display-inline: inline-block;
  typeahead-background: #646464;
  baseFormLineHeight: 32px;
  global100Percent: 100%;
  globalRadius: 0;
  bg-disabled: #eee;
  mobile-default: only screen and (min-width : 320x) and (max-width : 575px);
  mobile-large: only screen and (min-width : 576px) and (max-width : 766px);
  tablet-default: only screen and (min-width : 768px) and (max-width : 991px);
  desktop-small: only screen and (min-width : 992px) and (max-width : 1366px);
  desktop-default: only screen and (min-width : 1200px);
  desktop-large: only screen and (min-width : 1824px);
}
@font-face {
  font-family: 'EYInterstate Regular';
  src: url(${___CSS_LOADER_URL_REPLACEMENT_0___});
}
@font-face {
  font-family: 'EYInterstate Italic';
  font-style: italic;
  src: url(${___CSS_LOADER_URL_REPLACEMENT_1___});
}
@font-face {
  font-family: 'EYInterstate Bold';
  font-weight: bold;
  src: url(${___CSS_LOADER_URL_REPLACEMENT_2___});
}
@font-face {
  font-family: 'EYInterstate BoldItalic';
  font-style: italic;
  font-weight: bold;
  src: url(${___CSS_LOADER_URL_REPLACEMENT_3___});
}
@font-face {
  font-family: 'EYInterstate Light';
  font-weight: 300;
  src: url(${___CSS_LOADER_URL_REPLACEMENT_4___});
}
@font-face {
  font-family: 'EYInterstate LightItalic';
  font-style: italic;
  font-weight: 300;
  src: url(${___CSS_LOADER_URL_REPLACEMENT_5___});
}
/* default Global font sizes */
html {
  height: 100vh;
  width: 100%;
  font-size: 14px !important;
}
@media only screen and (min-width : 1367px) and (max-width : 1600px) {
  html {
    font-size: 12.61px !important;
  }
}
@media only screen and (min-width : 992px) and (max-width : 1366px) {
  html {
    font-size: 11.2px !important;
  }
}
@media only screen and (min-width : 768px) and (max-width : 991px) {
  html {
    font-size: 11.2px !important;
  }
}
body {
  height: 100%;
  width: 100%;
  overflow: hidden !important;
  margin: 0 auto;
  font-family: 'EYInterstate' !important;
  font-size: 14px !important;
}
@media only screen and (min-width : 1367px) and (max-width : 1600px) {
  body {
    font-size: 12.61px !important;
  }
}
@media only screen and (min-width : 992px) and (max-width : 1366px) {
  body {
    font-size: 11.2px !important;
  }
}
@media only screen and (min-width : 768px) and (max-width : 991px) {
  body {
    font-size: 11.2px !important;
  }
}
body * {
  font-family: 'EYInterstate';
}
h1 {
  font-size: var(--px-34);
  line-height: var(--px-42);
}
h2 {
  font-size: var(--px-28);
  line-height: var(--px-36);
}
h3 {
  font-size: var(--px-24);
  line-height: var(--px-32);
}
h4 {
  font-size: var(--px-20);
  line-height: var(--px-30);
}
h5 {
  font-size: var(--px-18);
  line-height: var(--px-28);
}
h6 {
  font-size: var(--px-16);
  line-height: var(--px-24);
}
label {
  line-height: var(--px-16);
}
.mainResponsiveWrapper {
  max-width: 100%;
  padding-left: var(--px-40) !important;
}
@media only screen and (min-width : 768px) and (max-width : 991px) {
  .mainResponsiveWrapper {
    padding-left: var(--px-25) !important;
  }
}
@media only screen and (min-width : 992px) and (max-width : 1366px) {
  .mainResponsiveWrapper {
    padding-left: var(--px-25) !important;
  }
}
@media only screen and (min-width: 1921px) {
  .mainResponsiveWrapper {
    padding: 0 !important;
    position: relative !important;
  }
}
@media only screen and (min-width: 1921px) {
  .mainResponsiveWrapper .DraggableGuidance {
    left: 0 !important;
  }
}
@media only screen and (min-width: 1921px) {
  .mainResponsiveWrapper.StyledTaskViewBreadcrumbs {
    padding-top: var(--px-20) !important;
    margin: 0 auto;
    padding-left: var(--px-126) !important;
  }
}
@media only screen and (min-width: 1921px) {
  .mainResponsiveWrapper.StyledAresViewFooter {
    height: var(--px-124) !important;
  }
}
@media only screen and (min-width: 1921px) {
  .mainResponsiveWrapper.StyledFormDetailsWrapper {
    padding: 0 var(--px-116) 0 var(--px-126) !important;
  }
}
@media only screen and (min-width: 1921px) {
  .mainResponsiveWrapper.StyledTaskDetailsWrapper {
    padding: 0 var(--px-116) 0 var(--px-126) !important;
  }
}
@media only screen and (min-width: 1921px) {
  .mainResponsiveWrapper.StyledAresFormBodyContainer {
    padding: 0 var(--px-116) var(--gwf-last-body-to-nav-spacing) var(--px-126) !important;
  }
}
@media only screen and (min-width: 1921px) {
  .mainResponsiveWrapper.SectionTopNameWrapper {
    padding: 0 var(--px-116) 0 var(--px-126) !important;
  }
}
@media only screen and (min-width: 1921px) {
  .mainResponsiveWrapper.AresWrapper {
    padding: 0 var(--px-116) 0 var(--px-126) !important;
  }
}
svg.extra-large {
  width: var(--px-36);
  height: var(--px-36);
  max-width: var(--px-36);
  max-height: var(--px-36);
}
svg.large {
  width: var(--px-24);
  height: var(--px-24);
  max-width: var(--px-24);
  max-height: var(--px-24);
}
svg.medium {
  width: var(--px-20);
  height: var(--px-20);
  max-width: var(--px-20);
  max-height: var(--px-20);
}
svg.small {
  width: var(--px-16);
  height: var(--px-16);
  max-width: var(--px-16);
  max-height: var(--px-16);
}
svg.disable {
  cursor: default;
  color: var(--neutrals-500);
  fill: var(--neutrals-500);
}
.error-message-wrapper {
  padding: 0;
  color: #2e2e38;
  display: table;
  width: 100%;
  font-size: var(--px-12);
  line-height: var(--px-18);
  border: var(--px-1) solid #7f7f7f;
}
.error-message-wrapper .error-message {
  display: table-cell;
  padding: var(--px-9) var(--px-10) var(--px-5);
  color: #2e2e38;
  background: #fff;
}
.errorIcon,
.success-icon,
.warning-icon,
.info-icon {
  background: url(${___CSS_LOADER_URL_REPLACEMENT_6___}) no-repeat var(--px-10) var(--px-10);
  width: var(--px-16);
  height: var(--px-16);
  padding: var(--px-18);
  display: table-cell;
  background-color: #b9251c;
  background-size: 50%;
}
.success-icon {
  background: url(${___CSS_LOADER_URL_REPLACEMENT_7___}) no-repeat var(--px-7) var(--px-7);
  background-color: #2c973e;
}
.warning-icon {
  background: url(${___CSS_LOADER_URL_REPLACEMENT_8___}) no-repeat var(--px-9) var(--px-7);
  background-color: #ff9831;
}
.info-icon {
  background: url(${___CSS_LOADER_URL_REPLACEMENT_9___}) no-repeat var(--px-9) var(--px-7);
  background-color: #747480;
}
`, "",{"version":3,"sources":["webpack://./components/globals.less","webpack://./components/vars.less"],"names":[],"mappings":"AAAA;;;;;gBAKgB;AAChB;;EAEE;AACF,WAAW;AACX,WAAW;ACuEX;EACC,eAAA;ADrED;AC0FA;EACC,qBAAA;EACA,iBAAA;EACA,oBAAA;EACA,iBAAA;EACA,oBAAA;EACA,qBAAA;EACA,wBAAA;EACA,kBAAA;EACA,qBAAA;EACA,eAAA;EACA,cAAA;EACA,kBAAA;EACA,kBAAA;EACA,mBAAA;EACA,aAAA;EACA,kBAAA;EACA,kBAAA;EACA,kBAAA;EACA,mBAAA;EACA,gBAAA;EACA,gBAAA;EACA,oBAAA;EACA,gBAAA;EACA,iBAAA;EACA,sBAAA;EACA,kBAAA;EACA,uBAAA;EACA,wBAAA;EACA,wCAAA;EACA,mBAAA;EACA,mBAAA;EACA,gBAAA;EACA,gBAAA;EACA,gBAAA;EACA,gBAAA;EACA,iBAAA;EAEA,wBAAA;EACA,yBAAA;EACA,6BAAA;EACA,6BAAA;EACA,uBAAA;EACA,kBAAA;EAEA,2BAAA;EACA,2BAAA;EACA,uBAAA;EACA,sBAAA;EACA,oBAAA;EACA,0BAAA;EACA,uBAAA;EACA,sBAAA;EACA,gCAAA;EACA,yBAAA;EACA,4BAAA;EACA,2BAAA;EACA,2BAAA;EACA,8BAAA;EACA,oBAAA;EACA,2BAAA;EACA,sBAAA;EACA,iBAAA;EACA,qBAAA;EACA,uBAAA;EACA,uBAAA;EACA,oBAAA;EACA,4BAAA;EACA,6BAAA;EACA,wBAAA;EACA,sBAAA;EACA,eAAA;EACA,iBAAA;EACA,0EAAA;EACA,yEAAA;EACA,2EAAA;EACA,2EAAA;EACA,qDAAA;EACA,mDAAA;AD1FD;AAnFA;EACC,mCAAA;EACA,4CAAA;AAqFD;AAnFA;EACC,kCAAA;EACA,kBAAA;EACA,4CAAA;AAqFD;AAnFA;EACC,gCAAA;EACA,iBAAA;EACA,4CAAA;AAqFD;AAnFA;EACC,sCAAA;EACA,kBAAA;EACA,iBAAA;EACA,4CAAA;AAqFD;AAnFA;EACC,iCAAA;EACA,gBAAA;EACA,4CAAA;AAqFD;AAnFA;EACC,uCAAA;EACA,kBAAA;EACA,gBAAA;EACA,4CAAA;AAqFD;AACA,8BAA8B;AAzD9B;EACC,aAAA;EACA,WAAA;EACA,0BAAA;AA2DD;AA1DC;EAAA;IACC,6BAAA;EA6DA;AACF;AA5DC;EAAA;IACC,4BAAA;EA+DA;AACF;AA9DC;EAAA;IACC,4BAAA;EAiEA;AACF;AA9DA;EACC,YAAA;EACA,WAAA;EACA,2BAAA;EACA,cAAA;EACA,sCAAA;EACA,0BAAA;AAgED;AA/DC;EAAA;IACC,6BAAA;EAkEA;AACF;AAjEC;EAAA;IACC,4BAAA;EAoEA;AACF;AAnEC;EAAA;IACC,4BAAA;EAsEA;AACF;AArFA;EAiBE,2BAAA;AAuEF;AAnEA;EACC,uBAAA;EACA,yBAAA;AAqED;AAlEA;EACC,uBAAA;EACA,yBAAA;AAoED;AAjEA;EACC,uBAAA;EACA,yBAAA;AAmED;AAhEA;EACC,uBAAA;EACA,yBAAA;AAkED;AA/DA;EACC,uBAAA;EACA,yBAAA;AAiED;AA9DA;EACC,uBAAA;EACA,yBAAA;AAgED;AA7DA;EACC,yBAAA;AA+DD;AA5DA;EACC,eAAA;EACA,qCAAA;AA8DD;AA7DC;EAAA;IACC,qCAAA;EAgEA;AACF;AA/DC;EAAA;IACC,qCAAA;EAkEA;AACF;AAjEC;EAAA;IACC,qBAAA;IACA,6BAAA;EAoEA;AACF;AAlEE;EAAA;IACC,kBAAA;EAqED;AACF;AAlEE;EAAA;IACC,oCAAA;IACA,cAAA;IACA,sCAAA;EAqED;AACF;AAlEE;EAAA;IACC,gCAAA;EAqED;AACF;AAlEE;EAAA;IACC,mDAAA;EAqED;AACF;AAlEE;EAAA;IACC,mDAAA;EAqED;AACF;AAlEE;EAAA;IACC,qFAAA;EAqED;AACF;AAlEE;EAAA;IACC,mDAAA;EAqED;AACF;AAlEE;EAAA;IACC,mDAAA;EAqED;AACF;AAhEC;EACC,mBAAA;EACA,oBAAA;EACA,uBAAA;EACA,wBAAA;AAkEF;AAhEC;EACC,mBAAA;EACA,oBAAA;EACA,uBAAA;EACA,wBAAA;AAkEF;AAhEC;EACC,mBAAA;EACA,oBAAA;EACA,uBAAA;EACA,wBAAA;AAkEF;AAhEC;EACC,mBAAA;EACA,oBAAA;EACA,uBAAA;EACA,wBAAA;AAkEF;AAhEC;EACC,eAAA;EACA,0BAAA;EACA,yBAAA;AAkEF;AA9DA;EACC,UAAA;EACA,cAAA;EACA,cAAA;EACA,WAAA;EACA,uBAAA;EACA,yBAAA;EACA,iCAAA;AAgED;AAvEA;EASE,mBAAA;EACA,6CAAA;EACA,cAAA;EACA,gBAAA;AAiEF;AA7DA;;;;EAIC,uFAAA;EACA,mBAAA;EACA,oBAAA;EACA,qBAAA;EACA,mBAAA;EACA,yBAAA;EACA,oBAAA;AA+DD;AA5DA;EACC,qFAAA;EACA,yBAAA;AA8DD;AA3DA;EACC,qFAAA;EACA,yBAAA;AA6DD;AA1DA;EACC,qFAAA;EACA,yBAAA;AA4DD","sourcesContent":["/* rastwe: 10/17/17 - I'm adding an @import here to point at the\n *  EY Online Style Guide. This is required because of some issues with\n *  The \"extract-text-webpack-plugin\", or webpack itself. In either case,\n *  relying on the @import order instead of webpack fixes the issue.\n *  TODO: undo this later, and just refer to the OSG in the top-level\n *  component. */\n@import './vars';\n\n@font-face {\n\tfont-family: 'EYInterstate Regular';\n\tsrc: url('~@ey-xd/motif-core/src/assets/fonts/EYInterstate-Regular.woff2');\n}\n@font-face {\n\tfont-family: 'EYInterstate Italic';\n\tfont-style: italic;\n\tsrc: url('~@ey-xd/motif-core/src/assets/fonts/EYInterstate-Italic.woff2');\n}\n@font-face {\n\tfont-family: 'EYInterstate Bold';\n\tfont-weight: bold;\n\tsrc: url('~@ey-xd/motif-core/src/assets/fonts/EYInterstate-Bold.woff2');\n}\n@font-face {\n\tfont-family: 'EYInterstate BoldItalic';\n\tfont-style: italic;\n\tfont-weight: bold;\n\tsrc: url('~@ey-xd/motif-core/src/assets/fonts/EYInterstate-BoldItalic.woff2');\n}\n@font-face {\n\tfont-family: 'EYInterstate Light';\n\tfont-weight: 300;\n\tsrc: url('~@ey-xd/motif-core/src/assets/fonts/EYInterstate-Light.woff2');\n}\n@font-face {\n\tfont-family: 'EYInterstate LightItalic';\n\tfont-style: italic;\n\tfont-weight: 300;\n\tsrc: url('~@ey-xd/motif-core/src/assets/fonts/EYInterstate-LightItalic.woff2');\n}\n\n/* default Global font sizes */\n\n// Small devices (phones, 320px and up)\n@mobile-default: ~'only screen and (min-width : 320x) and (max-width : 575px)';\n\n// Small devices (landscape phones, 576px and up)\n@mobile-large: ~'only screen and (min-width : 576px) and (max-width : 766px)';\n\n// All mobile devices (Mobiles, 768px and below)\n@all-mobiles: ~'only screen and (max-width : 767px)';\n\n// Medium devices (tablets, 768px and up)\n@tablet-default: ~'only screen and (min-width : 768px) and (max-width : 991px)';\n\n// Small desktops (small desktops, 992px and 1366px)\n@desktop-small: ~'only screen and (min-width : 992px) and (max-width : 1366px)';\n\n// Medium desktops (medium desktops, 1367px to 1600px)\n@desktop-medium: ~'only screen and (min-width : 1367px) and (max-width : 1600px)';\n\n// Large desktops (large desktops, 1200px and up)\n@desktop-default: ~'only screen and (min-width : 1200px)';\n\n// Extra large desktop (Extra large desktops, 1824px and up)\n@desktop-large: ~'only screen and (min-width : 1824px)';\n\nhtml {\n\theight: 100vh;// to apply background from ASU\n\twidth: 100%;\n\tfont-size: 14px !important;\n\t@media @desktop-medium {\n\t\tfont-size: 12.61px !important;\n\t}\n\t@media @desktop-small {\n\t\tfont-size: 11.2px !important;\n\t}\n\t@media @tablet-default {\n\t\tfont-size: 11.2px !important;\n\t}\n}\n\nbody {\n\theight: 100%;\n\twidth: 100%;\n\toverflow: hidden !important;\n\tmargin: 0 auto;\n\tfont-family: 'EYInterstate' !important;\n\tfont-size: 14px !important;\n\t@media @desktop-medium {\n\t\tfont-size: 12.61px !important;\n\t}\n\t@media @desktop-small {\n\t\tfont-size: 11.2px !important;\n\t}\n\t@media @tablet-default {\n\t\tfont-size: 11.2px !important;\n\t}\n\t* {\n\t\tfont-family: 'EYInterstate';\n\t}\n}\n\nh1 {\n\tfont-size: var(--px-34);\n\tline-height: var(--px-42);\n}\n\nh2 {\n\tfont-size: var(--px-28);\n\tline-height: var(--px-36);\n}\n\nh3 {\n\tfont-size: var(--px-24);\n\tline-height: var(--px-32);\n}\n\nh4 {\n\tfont-size: var(--px-20);\n\tline-height: var(--px-30);\n}\n\nh5 {\n\tfont-size: var(--px-18);\n\tline-height: var(--px-28);\n}\n\nh6 {\n\tfont-size: var(--px-16);\n\tline-height: var(--px-24);\n}\n\nlabel {\n\tline-height: var(--px-16);\n}\n\n.mainResponsiveWrapper {\n\tmax-width: 100%;\n\tpadding-left: var(--px-40) !important;\n\t@media @tablet-default {\n\t\tpadding-left: var(--px-25) !important;\n\t}\n\t@media @desktop-small {\n\t\tpadding-left: var(--px-25) !important;\n\t}\n\t@media only screen and (min-width: 1921px) {\n\t\tpadding: 0 !important;\n\t\tposition: relative !important;\n\t}\n\t.DraggableGuidance {\n\t\t@media only screen and (min-width: 1921px) {\n\t\t\tleft: 0 !important;\n\t\t}\n\t}\n\t&.StyledTaskViewBreadcrumbs {\n\t\t@media only screen and (min-width: 1921px) {\n\t\t\tpadding-top: var(--px-20) !important;\n\t\t\tmargin: 0 auto;\n\t\t\tpadding-left: var(--px-126) !important;\n\t\t}\n\t}\n\t&.StyledAresViewFooter {\n\t\t@media only screen and (min-width: 1921px) {\n\t\t\theight: var(--px-124) !important;\n\t\t}\n\t}\n\t&.StyledFormDetailsWrapper {\n\t\t@media only screen and (min-width: 1921px) {\n\t\t\tpadding: 0 var(--px-116) 0 var(--px-126) !important;\n\t\t}\n\t}\n\t&.StyledTaskDetailsWrapper {\n\t\t@media only screen and (min-width: 1921px) {\n\t\t\tpadding: 0 var(--px-116) 0 var(--px-126) !important;\n\t\t}\n\t}\n\t&.StyledAresFormBodyContainer {\n\t\t@media only screen and (min-width: 1921px) {\n\t\t\tpadding: 0 var(--px-116) var(--gwf-last-body-to-nav-spacing) var(--px-126) !important;\n\t\t}\n\t}\n\t&.SectionTopNameWrapper {\n\t\t@media only screen and (min-width: 1921px) {\n\t\t\tpadding: 0 var(--px-116) 0 var(--px-126) !important;\n\t\t}\n\t}\n\t&.AresWrapper {\n\t\t@media only screen and (min-width: 1921px) {\n\t\t\tpadding: 0 var(--px-116) 0 var(--px-126) !important;\n\t\t}\n\t}\n}\n\nsvg {\n\t&.extra-large {\n\t\twidth: var(--px-36);\n\t\theight: var(--px-36);\n\t\tmax-width: var(--px-36);\n\t\tmax-height: var(--px-36);\n\t}\n\t&.large {\n\t\twidth: var(--px-24);\n\t\theight: var(--px-24);\n\t\tmax-width: var(--px-24);\n\t\tmax-height: var(--px-24);\n\t}\n\t&.medium {\n\t\twidth: var(--px-20);\n\t\theight: var(--px-20);\n\t\tmax-width: var(--px-20);\n\t\tmax-height: var(--px-20);\n\t}\n\t&.small {\n\t\twidth: var(--px-16);\n\t\theight: var(--px-16);\n\t\tmax-width: var(--px-16);\n\t\tmax-height: var(--px-16);\n\t}\n\t&.disable {\n\t\tcursor: default;\n\t\tcolor: var(--neutrals-500);\n\t\tfill: var(--neutrals-500);\n\t}\n}\n\n.error-message-wrapper {\n\tpadding: 0;\n\tcolor: #2e2e38;\n\tdisplay: table;\n\twidth: 100%;\n\tfont-size: var(--px-12);\n\tline-height: var(--px-18);\n\tborder: var(--px-1) solid #7f7f7f;\n\t.error-message {\n\t\tdisplay: table-cell;\n\t\tpadding: var(--px-9) var(--px-10) var(--px-5);\n\t\tcolor: #2e2e38;\n\t\tbackground: #fff;\n\t}\n}\n\n.errorIcon,\n.success-icon,\n.warning-icon,\n.info-icon {\n\tbackground: url('../images/error-icon.svg') no-repeat var(--px-10) var(--px-10);\n\twidth: var(--px-16);\n\theight: var(--px-16);\n\tpadding: var(--px-18);\n\tdisplay: table-cell;\n\tbackground-color: #b9251c;\n\tbackground-size: 50%;\n}\n\n.success-icon {\n\tbackground: url('../images/success-icon.svg') no-repeat var(--px-7) var(--px-7);\n\tbackground-color: #2c973e;\n}\n\n.warning-icon {\n\tbackground: url('../images/warning-icon.png') no-repeat var(--px-9) var(--px-7);\n\tbackground-color: #ff9831;\n}\n\n.info-icon {\n\tbackground: url('../images/info-icon.png') no-repeat var(--px-9) var(--px-7);\n\tbackground-color: #747480;\n}\n","/**\n * Global LESS variables\n */\n\n/* Colors */\n@ey-black: #000;\n@ey-buttercup: #ffee99;\n@ey-green: #2c973e;\n@ey-green-50: #95cb89;\n@ey-lilac: #ac98db;\n@ey-lilac-50: #d8d2e0;\n@ey-link-blue: #336699;\n@ey-link-blue-50: #7fd1d6;\n@ey-purple: #91278f;\n@ey-purple-50: #c893c7;\n@ey-red: #f04c3e;\n@ey-white: #fff;\n@ey-yellow: #ffd200;\n@ey-orange: #f7941d;\n@gray-light: #f0f0f0;\n@gray: #c0c0c0;\n@gray-half: #81858b;\n@gray-34th: #44494f;\n@gray-dark: #24282d;\n@gray-charcoal: #333;\n@grey-50: #3b3838;\n@grey-70: #7f7f7f;\n@ey-sky-blue: #35b7c0;\n@ey-teal: #00a3ae;\n@gray-100: #44494f;\n@grey-light-bg: #f4f4f4;\n@gray-14th: #bec1c7;\n@ey-ready-green: #00a4ae;\n@ey-inqueuebadge: #fcd5b5;\n@ey-inprogressbadge: #d7e4bd;\n/* Layout */\n@footer-height: (@nav-height / 4) + @footer-padding * 2;\n@footer-padding: 5px;\n@nav-height: 80px;\n@screen-xs: 480px;\n@screen-sm: 768px;\n@screen-md: 992px;\n@screen-lg: 1200px;\n@label-font-weight: bold;\n@cursor-disabled: default;\n@labelWeightNormal: normal;\n@z-index-select-dropdown: 1060; // must be higher than a modal background (1050)\n//** Placeholder text color\n@input-color-placeholder: #999;\n@channelToolsWidth: 100%;\n@baseFontSize: 12px;\n@label-font-weight: bold;\n@toggleButtonBorder: #d9dadb;\n@toggleActiveButton: #ffe600;\n@buttonBorderRadius: 4px;\n@inputBorderRadius: 4px;\n@textColorWhite: #fff;\n@inputActiveBorder: #f7941d;\n@label-font-weight: bold;\n@baseVMFontSize: 0.77vw;\n@label-placeholder-color: #81858b;\n@formComponentHeight: 30px;\n@typeaheadTokenColor: #e7f4ff;\n@typeheadLabelColor: #1f8dd6;\n@typeheadDisabledColor: #ddd;\n@typeheadSelectedColor: #1f8dd6;\n@buttonDisabled: #ddd;\n@buttonActiveBorder: #bde7ea;\n@opacity-transparent: 1;\n@opacity-blur: 0.8;\n@ey-border-radius: 4px;\n@cursor-default: default;\n@cursor-pointer: pointer;\n@boxshadow-none: none;\n@display-inline: inline-block;\n@typeahead-background: #646464;\n@baseFormLineHeight: 32px;\n@global100Percent: 100%;\n@globalRadius: 0;\n@bg-disabled: #eee;\n\n.global-lh-pd-fs {\n\tpadding: 0 10px;\n}\n\n// Small devices (phones, 320px and up)\n@mobile-default: ~'only screen and (min-width : 320x)';\n\n// Small devices (landscape phones, 576px and up)\n@mobile-large: ~'only screen and (min-width : 576px)';\n\n// Medium devices (tablets, 768px and up)\n@tablet-default: ~'only screen and (min-width : 768px)';\n\n// Large devices (desktops, 992px and up)\n@desktop-small: ~'only screen and (min-width : 992px)';\n\n// Large desktops (large desktops, 1200px and up)\n@desktop-default: ~'only screen and (min-width : 1200px)';\n\n// Extra large desktop (large desktops, 1824px and up)\n@desktop-large: ~'only screen and (min-width : 1824px)';\n\n:export {\n\tey-buttercup: @ey-buttercup;\n\tey-green: @ey-green;\n\tey-green-50: @ey-green-50;\n\tey-lilac: @ey-lilac;\n\tey-lilac-50: @ey-lilac-50;\n\tey-link-blue: @ey-link-blue;\n\tey-link-blue-50: @ey-link-blue-50;\n\tey-purple: @ey-purple;\n\tey-purple-50: @ey-purple-50;\n\tey-red: @ey-red;\n\tey-white: @ey-white;\n\tey-yellow: @ey-yellow;\n\tey-orange: @ey-orange;\n\tgray-light: @gray-light;\n\tgray: @gray;\n\tgray-half: @gray-half;\n\tgray-34th: @gray-34th;\n\tgray-dark: @gray-dark;\n\tgray-charcoal: @gray-charcoal;\n\tgrey-50: @grey-50;\n\tgrey-70: @grey-70;\n\tey-sky-blue: @ey-sky-blue;\n\tey-teal: @ey-teal;\n\tgray-100: @gray-100;\n\tgrey-light-bg: @grey-light-bg;\n\tgray-14th: @gray-14th;\n\tey-ready-green: @ey-ready-green;\n\tey-inqueuebadge: @ey-inqueuebadge;\n\tey-inprogressbadge: @ey-inprogressbadge /* Layout */;\n\tfooter-height: @footer-height;\n\tfooter-padding: @footer-padding;\n\tnav-height: @nav-height;\n\tscreen-xs: @screen-xs;\n\tscreen-sm: @screen-sm;\n\tscreen-md: @screen-md;\n\tscreen-lg: @screen-lg;\n\tlabel-font-weight: @label-font-weight;\n\tcursor-disabled: @cursor-disabled;\n\tlabelWeightNormal: @labelWeightNormal;\n\tz-index-select-dropdown: @z-index-select-dropdown;\n\tinput-color-placeholder: @input-color-placeholder;\n\tchannelToolsWidth: @channelToolsWidth;\n\tbaseFontSize: @baseFontSize;\n\tlabel-font-weight: @label-font-weight;\n\ttoggleButtonBorder: @toggleButtonBorder;\n\ttoggleActiveButton: @toggleActiveButton;\n\tbuttonBorderRadius: @buttonBorderRadius;\n\tinputBorderRadius: @inputBorderRadius;\n\ttextColorWhite: @textColorWhite;\n\tinputActiveBorder: @inputActiveBorder;\n\tlabel-font-weight: @label-font-weight;\n\tbaseVMFontSize: @baseVMFontSize;\n\tlabel-placeholder-color: @label-placeholder-color;\n\tformComponentHeight: @formComponentHeight;\n\ttypeaheadTokenColor: @typeaheadTokenColor;\n\ttypeheadLabelColor: @typeheadLabelColor;\n\ttypeheadDisabledColor: @typeheadDisabledColor;\n\ttypeheadSelectedColor: @typeheadSelectedColor;\n\tbuttonDisabled: @buttonDisabled;\n\tbuttonActiveBorder: @buttonActiveBorder;\n\topacity-transparent: @opacity-transparent;\n\topacity-blur: @opacity-blur;\n\tey-border-radius: @ey-border-radius;\n\tcursor-default: @cursor-default;\n\tcursor-pointer: @cursor-pointer;\n\tboxshadow-none: @boxshadow-none;\n\tdisplay-inline: @display-inline;\n\ttypeahead-background: @typeahead-background;\n\tbaseFormLineHeight: @baseFormLineHeight;\n\tglobal100Percent: @global100Percent;\n\tglobalRadius: @globalRadius;\n\tbg-disabled: @bg-disabled;\n\tmobile-default: @mobile-default;\n\tmobile-large: @mobile-large;\n\ttablet-default: @tablet-default;\n\tdesktop-small: @desktop-small;\n\tdesktop-default: @desktop-default;\n\tdesktop-large: @desktop-large;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
